import defaultRoutes from 'xyz/src/app/routes/defaultRoutes'
import getRoutes     from 'xyz/src/app/routes/getRoutes'

import settings from './settings'

export default getRoutes( defaultRoutes , settings ) ;
